











































import Vue from 'vue'
import { ProductColorPattern } from '@/product/types'
import ModalSelectColorPattern  from '@/product/components/printingOptions/ModalSelectColorPattern.vue'

export default Vue.extend({
  components: {
    ModalSelectColorPattern
  },
  props: {
    enableDefaultMessage: {
      type: Boolean,
      default: true
    },
    colorPatterns: {
      type: Array as () => ProductColorPattern[],
      required: true
    },
    selectedPattern: {
      type: Object as () => ProductColorPattern,
      default: undefined
    },
    isNotSupportPrinting: {
      type: Boolean,
      default: false
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: undefined
    }
  },
  data(): {
    showModalSelectColorPattern: boolean
  } {
    return {
      showModalSelectColorPattern: false
    }
  },
  methods: {
    toggleShowModalSelectColorPattern() {
      this.showModalSelectColorPattern = !this.showModalSelectColorPattern
    },
    onUpdateColorPattern(id: string) {
      this.$emit('update', id)
      this.toggleShowModalSelectColorPattern()
    }
  }
})
